export default __webpack_public_path__ + "static/media/icon-search.d1cf29be.svg";